import { FreshServiceProposalWash } from "@repo/common"
import { useFieldContext } from "../hooks/form-contexts"
import { ServiceProposalWashCard } from "./service-proposal-wash-card"

export interface ServiceProposalWashActionsFieldProps {
  wash: FreshServiceProposalWash
}

export const ServiceProposalWashField = ({
  wash,
}: ServiceProposalWashActionsFieldProps) => {
  const field = useFieldContext<string | undefined>()
  const isSelected = field.state.value === wash.originalWashId

  const handleSelect = () => {
    const newValue = isSelected ? "" : wash.originalWashId
    field.handleChange(newValue)
  }

  return (
    <ServiceProposalWashCard
      key={wash.originalWashId}
      data={wash}
      selected={isSelected}
      onSelect={handleSelect}
    />
  )
}
